<template>
  <div :class="$style.page">
    <BaseContainer :class="$style.container">
      <form @submit.prevent="submit">
        <BaseLoader
          :class="$style.box"
          :is-active="isFormLoading"
        >
          <FormBox
            :heading="formStepData.heading"
            :lead="formStepData.lead"
          >
            <template v-if="formStep === 1">
              <BaseField
                is-required
                :class="$style.field"
              >
                <BaseInput
                  type="file"
                  :class="$style.selectSourceCarsFile"
                  @change="onFileChange"
                />
              </BaseField>
              <BaseField
                is-required
                :class="$style.field"
              >
                <template #label>
                  Year
                </template>

                <BaseSelect
                  v-model="year"
                  :class="$style.multiselect"
                >
                  <option disabled>
                    Select
                  </option>
                  <option
                    v-for="option in $options.YEARS"
                    :key="option"
                    :value="option"
                  >
                    {{ option }}
                  </option>
                </BaseSelect>
              </BaseField>
              <BaseField
                is-required
                :class="$style.field"
              >
                <template #label>
                  Quater
                </template>

                <BaseSelect
                  v-model="quater"
                  :class="$style.multiselect"
                >
                  <option disabled>
                    Select
                  </option>
                  <option
                    v-for="option in $options.QUATERS"
                    :key="option"
                    :value="option"
                  >
                    {{ option }}
                  </option>
                </BaseSelect>
              </BaseField>
            </template>

            <template #footer>
              <BaseButton
                v-if="excel_cars.length > 0 && !importInProgress"
                variant="success"
                type="submit"
                is-block
              >
                {{ formStepData.submitText }}
              </BaseButton>
              <BaseButton
                v-if="fileProcessing"
                variant="secondary"
                is-block
                :disabled="isDisabled"
              >
                Transferring file, please wait...
              </BaseButton>
              <BaseButton
                v-if="importInProgress"
                variant="secondary"
                is-block
                :disabled="isDisabled"
              >
                Import in progress, this may be long (5 mins), please wait...
              </BaseButton>
            </template>
          </FormBox>
        </BaseLoader>
      </form>
    </BaseContainer>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import gql from 'graphql-tag';
import readXlsxFile from 'read-excel-file';
import moment from 'moment';
import sha256 from 'crypto-js/sha256';
import { v4 as uuidv4 } from 'uuid';
import BaseContainer from '@/components/base/Container';
import BaseField from '@/components/base/Field';
import BaseInput from '@/components/base/Input';
import BaseSelect from '@/components/base/Select';
import BaseButton from '@/components/base/Button';
import BaseLoader from '@/components/base/Loader';
import FormBox from '@/components/FormBox';

export default {
  components: {
    BaseContainer,
    BaseField,
    BaseInput,
    BaseSelect,
    BaseButton,
    BaseLoader,
    FormBox,
  },
  YEARS: [2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032],
  QUATERS: ['Q1', 'Q2', 'Q3', 'Q4'],
  FORM_STEPS_DATA: [
    {
      heading: 'Import source cars',
      submitText: 'Start import to database',
    },
    {
      heading: 'Cars imported',
      submitText: 'Go to the main page',
    },
  ],
  data() {
    return {
      file: null,
      file_id: null,
      file_name: null,
      file_hash: null,
      fileProcessing: false,
      importInProgress: false,
      excel_cars: [],
      cluster_refs: [],
      excel_refs: [],
      excel_rows: [],
      db_primary_cars_ids: [],
      input_brands: [],
      existing_refs: [],
      new_refs: [],
      missing_refs: [],
      schema: {
        supplierOne: {
          'Mnemonic Vehicle': {
            prop: 'mnemonic_vehicle',
            type: String,
          },
          'Mnemonic Vehicle/Plant': {
            prop: 'mnemonic_vehicle_plant',
            type: String,
          },
          'Mnemonic Platform': {
            prop: 'mnemonic_platform',
            type: String,
          },
          'Mnemonic Plant': {
            prop: 'mnemonic_plant',
            type: String,
          },
          'Mnemonic Core Nameplate Region': {
            prop: 'mnemonic_core_nameplate_region',
            type: String,
          },
          'Mnemonic Core Nameplate Plant': {
            prop: 'mnemonic_core_nameplate_plant',
            type: String,
          },
          'Mnemonic Core Vehicle Bodytype Plant': {
            prop: 'mnemonic_core_vehicle_bodytype_plant',
            type: String,
          },
          'Mnemonic Core Vehicle Bodystyle Plant': {
            prop: 'mnemonic_core_vehicle_bodystyle_plant',
            type: String,
          },
          'Mnemonic Vehicle Bodystyle': {
            prop: 'mnemonic_vehicle_bodystyle',
            type: String,
          },
          'Mnemonic Vehicle Bodystyle/Plant': {
            prop: 'mnemonic_vehicle_bodystyle_plant',
            type: String,
          },
          'Production Plant': {
            prop: 'production_plant',
            type: String,
          },
          'Source Plant': {
            prop: 'source_plant',
            type: String,
          },
          'Source Plant Country/Territory': {
            prop: 'source_plant_country_territory',
            type: String,
          },
          Manufacturer: {
            prop: 'manufacturer',
            type: String,
          },
          'Production Brand': {
            prop: 'production_brand',
            type: String,
          },
          'Production Nameplate': {
            prop: 'production_nameplate',
            type: String,
          },
          Platform: {
            prop: 'platform',
            type: String,
          },
          Program: {
            prop: 'program',
            type: String,
          },
          'Global Nameplate': {
            prop: 'global_nameplate',
            type: String,
          },
          'SOP (Start of Production)': {
            prop: 'sop',
            type: (value) => {
              if (value) {
                let parsedValue = moment(value).format('YYYY-MM-DD');
                if (parsedValue === 'Invalid date') {
                  parsedValue = null;
                }
                return parsedValue;
              }
              return null;
            },
          },
          'EOP (End of Production)': {
            prop: 'eop',
            type: (value) => {
              if (value) {
                let parsedValue = moment(value).format('YYYY-MM-DD');
                if (parsedValue === 'Invalid date') {
                  parsedValue = null;
                }
                return parsedValue;
              }
              return null;
            },
          },
          Bodystyle: {
            prop: 'body_style',
            type: String,
          },
          Bodytype: {
            prop: 'body_type',
            type: String,
          },
          'Bodystyle Program Code': {
            prop: 'body_style_program_code',
            type: String,
          },
          'Bodystyle SOP': {
            prop: 'body_style_sop',
            type: (value) => {
              if (value) {
                let parsedValue = moment(value).format('YYYY-MM-DD');
                if (parsedValue === 'Invalid date') {
                  parsedValue = null;
                }
                return parsedValue;
              }
              return null;
            },
          },
          'Bodystyle EOP': {
            prop: 'body_style_eop',
            type: (value) => {
              if (value) {
                let parsedValue = moment(value).format('YYYY-MM-DD');
                if (parsedValue === 'Invalid date') {
                  parsedValue = null;
                }
                return parsedValue;
              }
              return null;
            },
          },
          'Production Type': {
            prop: 'production_type',
            type: String,
          },
          'GVW Class': {
            prop: 'gvw_class',
            type: String,
          },
          'Global Production Segment': {
            prop: 'global_production_segment',
            type: String,
          },
          'Global Production Price Class': {
            prop: 'global_production_price_class',
            type: String,
          },
          'Global Sales Segment': {
            prop: 'global_sales_segment',
            type: String,
          },
          'Global Sales Sub-Segment': {
            prop: 'global_sales_sub_segment',
            type: String,
          },
          'Global Sales Price Class': {
            prop: 'global_sales_price_class',
            type: String,
          },
          CY2015: {
            prop: 'cy2015',
          },
          CY2016: {
            prop: 'cy2016',
          },
          CY2017: {
            prop: 'cy2017',
          },
          'CY 2018': {
            prop: 'cy2018',
          },
          'CY 2019': {
            prop: 'cy2019',
          },
          'CY 2020': {
            prop: 'cy2020',
          },
          'CY 2021': {
            prop: 'cy2021',
          },
          'CY 2022': {
            prop: 'cy2022',
          },
          'CY 2023': {
            prop: 'cy2023',
          },
          'CY 2024': {
            prop: 'cy2024',
          },
          'CY 2025': {
            prop: 'cy2025',
          },
          'CY 2026': {
            prop: 'cy2026',
          },
          'CY 2027': {
            prop: 'cy2027',
          },
          'CY 2028': {
            prop: 'cy2028',
          },
          'CY 2029': {
            prop: 'cy2029',
          },
        },
        supplierTwo: {
          'LMCA BODYSTYLE CODE': {
            prop: 'lmca_bodystyle_code',
            type: String,
          },
          'LMCA FULL CODE': {
            prop: 'lmca_full_code',
            type: String,
          },
          'LMCA MODEL CODE': {
            prop: 'lmca_model_code',
            type: String,
          },
          REGION: {
            prop: 'region',
            type: String,
          },
          'TRADE REGION': {
            prop: 'trade_region',
            type: String,
          },
          COUNTRY: {
            prop: 'country',
            type: String,
          },
          'SALES GROUP': {
            prop: 'sales_group',
            type: String,
          },
          MANUFACTURER: {
            prop: 'manufacturer',
            type: String,
          },
          'LOCAL MAKE': {
            prop: 'local_make',
            type: String,
          },
          'LOCAL MODEL LINE': {
            prop: 'local_model_line',
            type: String,
          },
          'LOCAL PROGRAM CODE': {
            prop: 'local_program_code',
            type: String,
          },
          'LOCAL PRODUCTION MODEL': {
            prop: 'local_production_model',
            type: String,
          },
          'GLOBAL MAKE': {
            prop: 'global_make',
            type: String,
          },
          'GLOBAL PRODUCTION MODEL': {
            prop: 'global_production_model',
            type: String,
          },
          GVW: {
            prop: 'gvw',
            type: String,
          },
          PLATFORM: {
            prop: 'plateform',
            type: String,
          },
          'DESIGN LEAD': {
            prop: 'design_lead',
            type: String,
          },
          'DESIGN LEAD LOCATION': {
            prop: 'designe_lead_location',
            type: String,
          },
          'DESIGN LEAD COUNTRY': {
            prop: 'design_lead_country',
            type: String,
          },
          'VEHICLE PLANT': {
            prop: 'vehicule_plant',
            type: String,
          },
          CITY: {
            prop: 'city',
            type: String,
          },
          LOCATION: {
            prop: 'location',
            type: String,
          },
          LATITUDE: {
            prop: 'latitude',
          },
          LONGITUDE: {
            prop: 'longitude',
          },
          'PRODUCTION TYPE': {
            prop: 'production_type',
            type: String,
          },
          TYPE: {
            prop: 'type',
            type: String,
          },
          'REGIONAL SIZE': {
            prop: 'regional_size',
            type: String,
          },
          'REGIONAL BODY TYPE': {
            prop: 'regional_body_type',
            type: String,
          },
          'REGIONAL STATUS': {
            prop: 'regional_status',
            type: String,
          },
          'GLOBAL SIZE': {
            prop: 'global_size',
            type: String,
          },
          'GLOBAL BODY TYPE': {
            prop: 'global_body_type',
            type: String,
          },
          'GLOBAL STATUS': {
            prop: 'global_status',
            type: String,
          },
          BODYSTYLE: {
            prop: 'bodystyle',
            type: String,
          },
          DOORS: {
            prop: 'doors',
            type: String,
          },
          'SOP: VEHICLE': {
            prop: 'sop',
            type: (value) => {
              if (value) {
                let parsedValue = moment(value).format('DD/MM/YYYY');
                if (parsedValue === 'Invalid date') {
                  parsedValue = null;
                }
                return parsedValue;
              }
              return null;
            },
          },
          'EOP: VEHICLE': {
            prop: 'eop',
            type: (value) => {
              if (value) {
                let parsedValue = moment(value).format('DD/MM/YYYY');
                if (parsedValue === 'Invalid date') {
                  parsedValue = null;
                }
                return parsedValue;
              }
              return null;
            },
          },
          'NEXT FACELIFT': {
            prop: 'next_facelift',
            type: (value) => {
              if (value) {
                let parsedValue = moment(value).format('DD/MM/YYYY');
                if (parsedValue === 'Invalid date') {
                  parsedValue = null;
                }
                return parsedValue;
              }
              return null;
            },
          },
          'LAST ACTUAL': {
            prop: 'last_actual',
            type: (value) => {
              if (value) {
                let parsedValue = moment(value).format('DD/MM/YYYY');
                if (parsedValue === 'Invalid date') {
                  parsedValue = null;
                }
                return parsedValue;
              }
              return null;
            },
          },
          'POWER TRAIN': {
            prop: 'power_train',
            type: String,
          },
          'BODYSTYLE PROGRAM CODE': {
            prop: 'bodystyle_program_code',
            type: String,
          },
          2016: {
            prop: 'y2016',
          },
          2017: {
            prop: 'y2017',
          },
          2018: {
            prop: 'y2018',
          },
          2019: {
            prop: 'y2019',
          },
          2020: {
            prop: 'y2020',
          },
          2021: {
            prop: 'y2021',
          },
          2022: {
            prop: 'y2022',
          },
          2023: {
            prop: 'y2023',
          },
          2024: {
            prop: 'y2024',
          },
          2025: {
            prop: 'y2025',
          },
          2026: {
            prop: 'y2026',
          },
          2027: {
            prop: 'y2027',
          },
          2028: {
            prop: 'y2028',
          },
          2029: {
            prop: 'y2029',
          },
          2030: {
            prop: 'y2030',
          },
        },
      },
      formStep: 1,
      isFormLoading: false,
      updateTaskStatus: {},
      quater: `Q${moment().utc().quarter()}`,
      year: moment().year(),
      supplierId: '',
    };
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('user', ['isAdmin', 'isCompanyAdmin']),
    formStepData() {
      return this.$options.FORM_STEPS_DATA[this.formStep - 1];
    },
  },
  methods: {
    async onFileChange(event) {
      const xlsxfile = event.target.files[0];
      this.fileProcessing = true;
      this.file_id = uuidv4();
      this.file_name = xlsxfile.name;
      let columnsNames = null;

      try {
        columnsNames = await readXlsxFile(xlsxfile);
        [columnsNames] = columnsNames;
      } catch (err) {
        return false;
      }

      let schema = {};
      if (columnsNames.includes('LMCA FULL CODE')) {
        schema = {
          ...this.schema.supplierTwo,
        };
        this.supplierId = 2;
      } else if (columnsNames.includes('Mnemonic Vehicle')) {
        schema = {
          ...this.schema.supplierOne,
        };
        this.supplierId = 1;
      } else {
        return false;
      }
      readXlsxFile(xlsxfile, { schema })
        .then((rows) => {
          this.excel_rows = rows.rows;
          this.file_hash = sha256(JSON.stringify(rows)).toString();
          this.update_cars();
        })
        .catch((error) => { console.log(error); });
      return true;
    },
    update_cars() {
      this.excel_cars = this.excel_rows.map((row) => {
        const updateRefId = `LMI${this.year}${this.quater}`.toLowerCase();
        let ref = `${row.production_brand}-${row.global_nameplate}-\
              ${row.body_style_program_code}-${row.body_type}-${row.source_plant}`;
        ref = ref.replace(/\s/g, '').toLowerCase();
        ref = sha256(process.env.VUE_APP_HASH_TOKEN + ref).toString();
        return (
          {
            ...row,
            update_ref_id: updateRefId,
            lighting_cluster_reference: ref,
          }
        );
      });
      this.fileProcessing = false;
    },
    async writeToDB() {
      this.isFormLoading = true;
      this.importInProgress = true;
      await this.$apollo.mutate({
        mutation: gql`
          mutation (
            $objects: [
              source_cars_supplier_${this.supplierId}_${this.user.company.uuid.replace(/-/g, '')}_insert_input!
            ] = {}
          ) {
            insert_source_cars_supplier_${this.supplierId}_${this.user.company.uuid.replace(/-/g, '')}
            (objects: $objects) {
              affected_rows
            }
          }
        `,
        variables: {
          objects: this.excel_cars,
        },
      });
      await this.$apollo.mutate({
        mutation: gql`
          mutation ($objects: [import_history_insert_input!] = {}) {
            insert_import_history(objects: $objects) {
              affected_rows
            }
          }
        `,
        variables: {
          objects: [
            {
              file_name: this.file_name,
              uuid: `LMI${this.year}${this.quater}`.toLowerCase(),
              file_hash: this.file_hash,
              update_ref: `LMI-${this.year}-${this.quater}`,
              company_id: this.user.company.uuid.replace(/-/g, ''),
              company_name: this.user.company.name.replace(/\s/g, '_').toLowerCase(),
              supplier: this.supplierId,
            },
          ],
        },
      });
      this.formStep = 2;
      this.isFormLoading = false;
      this.importInProgress = false;
    },
    submit() {
      switch (this.formStep) {
        case 1:
          return this.writeToDB();
        case 2:
          return this.$router.push({ name: 'Home' });
        default:
          return null;
      }
    },
  },
};
</script>

<style lang="scss" module>
.page {
  flex-grow: 1;
  padding-top: map-get($page-vertical-paddings, 'small');
  padding-bottom: map-get($page-vertical-paddings, 'small');
}

.selectSourceCarsFile {
  width: 100%;
}

.container {
  display: flex;
  justify-content: center;
}

.box {
  width: 470px;
}

.field {

  &:not(:first-child) {
    margin-top: 20px;
  }
}

.multiselect {
  width: 100%;
}
</style>
